import classNames from "classnames";
import IconBin from "@/components/Icon/IconBin.svg";
import IconStarGray from "@/components/Icon/IconStarGray.svg";
import IconStarGold from "@/components/Icon/IconStarGold.svg";

import React from "react";
import Link from "next/link";
import Image from "next/image";
import VehicleFitmentCheck from "../VehicleFitmentCheck";
import dynamic from "next/dynamic";
import { IMAGE_SIZES } from "@/constants";
const ProductClick = dynamic(() => import("../ProductClick", { ssr: false }));
const WishList = dynamic(() => import("../WishList", { ssr: false }));

export default function ProductItem({
  product = {},
  index,
  isSearch,
  className,
  enableDelete = false,
  showFitment,
  vehicle,
  onDelete,
  ...props
}) {
  let urlProduct = "";
  if (product.type === "new_bike")
    if (product.product_range_slugs && product.product_range_slugs.length > 0) {
      urlProduct = `/new-bikes/${product.manufacturer.toLowerCase()}/${product.product_range_slugs[0]}/${
        product.prismic_uid
      }`;
    } else {
      urlProduct = `/new-bikes/${product.manufacturer.toLowerCase()}/${product.prismic_uid}`;
    }
  if (product.type === "used_bike") urlProduct = `/used-bikes/${product.prismic_uid}`;
  if (product.type === "new_bike" || product.type === "used_bike") {
    return (
      <Link href={urlProduct}>
        <div
          className={classNames("flex flex-col px-2 lg:px-0 relative", {
            [className]: className,
          })}
          {...props}
        >
          {product.image_url ? (
            <Image
              src={product.image_url}
              alt={product.title}
              className="dark:invert h-[154px] lg:h-[207px] xl:h-[256px] w-[154px] lg:w-[207px] xl:w-[256px] object-contain"
              sizes="(max-width: 768px) 154px, (max-width: 1024px) 207px, 256px"
              width={256}
              height={256}
              priority={index < 8}
            />
          ) : (
            <div className="w-full min-w-[154px]  min-h-[154px] max-h-[154px] mb-4"></div>
          )}

          <div className="mt-auto">
            {showFitment && <VehicleFitmentCheck fitIds={product.vehicle_ids} vehicle={vehicle} />}
          </div>
          <div className="min-h-[50px] text-sm md:text-lg font-[500] leading-[23px] line-clamp-2 font-rajdhani">
            {product.product_name}
          </div>
          <div className="flex gap-2 font-rajdhani">
            {product.special_price > 0 && (
              <div className="flex text-red">
                <span className="text-xl font-[700]">
                  &#36;{String(product.special_price.toLocaleString()).split(".")[0]}
                </span>
                <span className="text-sm font-[700] leading-[26px]">{String(product.special_price).split(".")[1]}</span>
              </div>
            )}
            {product.price && (
              <div
                className={classNames("flex", {
                  "text-grey line-through": product.special_price,
                  "text-black": !product.special_price,
                })}
              >
                <span className="text-xl font-[700]">&#36;{String(product.price.toLocaleString()).split(".")[0]}</span>
                <span className="text-sm font-[700] leading-[26px]">{String(product.price).split(".")[1]}</span>
              </div>
            )}
          </div>
          {product.best_buys === true && (
            <Image
              src="/best-buys-icon.png"
              alt="Bikebiz Best Buys"
              width={64}
              height={64}
              className="w-[52px] md:w-[75px] h-[52px] md:h-[75px] absolute -top-2 -right-2 -md:right-3"
            />
          )}
        </div>
      </Link>
    );
  }
  return (
    <Link href={`/products/${product.url_key}`}>
      <div
        className={classNames("flex flex-col px-2 lg:px-0 relative", {
          [className]: className,
        })}
        {...props}
      >
        {product.image ? (
          <Image
            src={product.image}
            alt={product.title}
            className="dark:invert h-[154px] lg:h-[207px] xl:h-[256px] w-[154px] lg:w-[207px] xl:w-[256px] object-contain"
            sizes="(max-width: 768px) 154px, (max-width: 1024px) 207px, 256px"
            width={256}
            height={256}
            priority={index < 8}
          />
        ) : (
          <div className="w-full min-w-[154px]  min-h-[154px] max-h-[154px] mb-4"></div>
        )}

        <div className="mt-auto">
          {showFitment && <VehicleFitmentCheck fitIds={product.vehicle_ids} vehicle={vehicle} />}
          <div className="min-h-[22px]  flex gap-[6px]">
            {product.colour &&
              product.colour.length > 0 &&
              product.colour.map((color, index) => (
                <div
                  key={`product-colour-${index}}`}
                  className="w-[16px] h-[16px] rounded-full border-[1px] border-light-grey"
                  style={{ backgroundColor: JSON.parse(color)?.hex }}
                ></div>
              ))}
          </div>
        </div>
        <div className="min-h-[50px] text-sm md:text-lg font-[500] leading-[23px] line-clamp-2 font-rajdhani">
          {product.title}
        </div>
        <div className="flex gap-2 font-rajdhani">
          {product.discount_price > 0 && (
            <div className="flex text-red">
              <span className="text-xl font-[700]">&#36;{String(product.discount_price).split(".")[0]}</span>
              <span className="text-sm font-[700] leading-[26px]">{String(product.discount_price).split(".")[1]}</span>
            </div>
          )}
          <div
            className={classNames("flex", {
              "text-grey line-through": product.discount_price,
              "text-black": !product.discount_price,
            })}
          >
            <span className="text-xl font-[700]">&#36;{String(product.price).split(".")[0]}</span>
            <span className="text-sm font-[700] leading-[26px]">{String(product.price).split(".")[1]}</span>
          </div>
        </div>
        <div className="flex items-center">
          <div className="flex gap-1">
            {[...Array(5)].map((_, index) =>
              index < product.rating ? (
                <Image key={`star-${index}`} src={IconStarGold.src} alt="" width={14} height={14} />
              ) : (
                <Image key={`star-${index}`} src={IconStarGray.src} alt="" width={14} height={14} />
              )
            )}
          </div>

          <label className="text-grey ml-2 text-xs mt-1">({product.review_count ? product.review_count : 0})</label>
          {!enableDelete && (
            <WishList
              product={{
                id: product.storefrontId,
                name: product.title,
              }}
            />
          )}
        </div>
        {product.best_buys === true && (
          <Image
            src="/best-buys-icon.png"
            alt="Bikebiz Best Buys"
            width={64}
            height={64}
            className="w-[52px] md:w-[75px] h-[52px] md:h-[75px] absolute -top-2 -right-2 -md:right-3"
          />
        )}
        {enableDelete && (
          <div
            className="flex items-center gap-2 text-xs font-roboto font-[600] mt-2 cursor-pointer"
            onClick={e => {
              e.preventDefault();
              onDelete();
            }}
          >
            <Image src={IconBin.src} alt="Heart" width="16" height="16" />
            REMOVE
          </div>
        )}
        <ProductClick product={product} index={index} isSearch={isSearch}></ProductClick>
      </div>
    </Link>
  );
}
